import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { privateApi } from "../../lib/privateApi";
import { devWarn } from "../../lib/devLog";

/**
 * /private/logout — clears the `act_nda` cookie server-side then bounces
 * the visitor to /private/access.
 */
export default function PrivateLogout() {
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                await privateApi.logout();
            } catch (err) {
                devWarn("private.logout failed; redirecting anyway:", err);
            }
            navigate("/private/access", { replace: true });
        })();
    }, [navigate]);

    return (
        <div
            className="min-h-screen bg-[#0B0B0C] flex items-center justify-center"
            data-testid="private-logout"
        >
            <div className="w-32 h-px bg-[rgba(201,168,106,0.3)] relative overflow-hidden">
                <span className="absolute inset-y-0 left-0 w-1/3 bg-[#C9A86A] animate-[slide_1.2s_ease-in-out_infinite]" />
            </div>
            <style>{`@keyframes slide {0%{transform:translateX(-100%)}100%{transform:translateX(400%)}}`}</style>
        </div>
    );
}
